export const isValidEmail = email => {
  if (typeof email !== 'string') {
    return false;
  }
  return /^\S+@\S+\.\S+$/.test(email);
};
